import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  redirectOnForbiddenError,
  redirectOnNotFoundError,
} from '../utils/error/useErrorRedirectEffect';
import PageMeta from '../utils/PageMeta';
import { parseSlug } from '../utils/router/useSlug';
import ContentMap from './ContentMap';
import {
  useAllTopicMap,
  useRedactedTopicIds,
  useTopicsHasLoaded,
} from './useAllTopics';
import { useAppDispatch } from '../app/redux/useAppSelector';
import useNavigate from '../utils/router/useNavigate';

interface BaseTopicSubtopicsViewProps {
  topicSlug: string;
}

const BaseTopicSubtopicsView = ({ topicSlug }: BaseTopicSubtopicsViewProps) => {
  const [topicId] = parseSlug(topicSlug);
  const redactedTopicIds = useRedactedTopicIds();
  const hasLoaded = useTopicsHasLoaded();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const allTopicMap = useAllTopicMap();
  const topic = allTopicMap[topicId];

  let error: 'notFound' | 'forbidden' | null = null;
  if (!topic && hasLoaded) {
    error = redactedTopicIds.has(topicId) ? 'forbidden' : 'notFound';
  }
  useEffect(() => {
    if (error === 'forbidden') {
      redirectOnForbiddenError({ noun: 'topic', dispatch, navigate });
    } else if (error === 'notFound') {
      redirectOnNotFoundError({ noun: 'topic', dispatch, navigate });
    }
  }, [error, dispatch, navigate]);

  if (!topic) return null;

  return (
    <div id="content" className="no-padding-x no-padding-y">
      <PageMeta title={`${topic.name} - Slab`} />
      <ContentMap topicId={topic.id} />
    </div>
  );
};

const TopicSubtopicsView = () => {
  const { topicSlug } = useParams<{ topicSlug: string }>();
  return topicSlug ? <BaseTopicSubtopicsView topicSlug={topicSlug} /> : null;
};

export default TopicSubtopicsView;
